// extracted by mini-css-extract-plugin
export default {"copy":"ContactModal_copy__0gV0A"};